import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { showroom, contact } from "../data/site";

// "Visit our showroom" — image + address + map / appointment CTAs.
export default function Showroom() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="container-luxe grid items-center gap-10 lg:grid-cols-2 lg:gap-20">
        <Reveal className="relative order-1">
          <div className="overflow-hidden">
            <img
              src={showroom.image}
              alt="Culture Diamond Jewels showroom — Ten-11, C.G. Road, Ahmedabad"
              className="h-[340px] w-full object-cover sm:h-[460px] lg:h-[560px]"
            />
          </div>
          <div className="absolute -bottom-5 -left-5 hidden h-28 w-28 border border-gold/40 lg:block" />
        </Reveal>

        <Reveal delay={150} className="order-2">
          <p className="eyebrow mb-4 md:mb-5">The Boutique</p>
          <h2 className="section-title mb-6">{showroom.heading}</h2>
          <p className="max-w-md font-sans text-base font-light leading-relaxed text-charcoal/70">
            {showroom.text}
          </p>

          <div className="mt-8 space-y-1 font-serif text-lg text-charcoal/85">
            {contact.addressLines.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </div>
          <p className="mt-2 font-sans text-sm tracking-wide text-charcoal/55">
            {contact.hours}
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row">
            <Link to="/contact" className="btn-gold">
              Book an Appointment
            </Link>
            <a
              href={showroom.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-sans text-xs uppercase tracking-[0.25em] text-charcoal/70 underline-offset-8 transition-colors hover:text-gold-dark hover:underline"
            >
              Get Directions →
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
